<template>
  <div
    id="fullpage"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="module1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="text" class="gaiAModule1">
        <div id="text1" class="module1">
          PDRHea<sup class="sup">®</sup>
          {{ $t("productCenterPDRHeaView").module.h1 }}
        </div>
        <div id="text3" class="module1">
          {{ $t("productCenterPDRHeaView").module.h2 }}
        </div>
      </div>
    </div>
    <div
      id="module2"
      :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
      v-lazy="imageUrl2"
    >
      <div id="module2Content">
        <div id="title1" class="wow animate__animated animate__fadeInUp">
          {{ $t("productCenterPDRHeaView").module.h3 }}
        </div>
        <div id="title2" class="wow animate__animated animate__fadeInUp">
          {{ $t("productCenterPDRHeaView").module.h4 }}
        </div>
        <div id="video" class="wow animate__animated animate__fadeInUp">
          <div class="leftVideo">
            <div class="title nirvana_bg">
              Gen1 - {{ $t("productCenterPDRHeaView").module.h12 }}
            </div>
            <video
              ref="videoPlayer"
              controlsList="nodownload"
              controls
              src="@/static/img/PDRHEA_nirvana.mp4"
              muted
              autoplay
              loop
            ></video>
          </div>
          <div class="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="103"
              height="44"
              viewBox="0 0 103 44"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M72.5515 2.04059C72.5515 0.384784 74.4486 -0.553845 75.7649 0.450685L101.917 20.4085C102.966 21.209 102.966 22.7879 101.917 23.5883L75.7649 43.5461C74.4486 44.5507 72.5515 43.612 72.5515 41.9562V36.4985H-0.000211607V7.49828H72.5515V2.04059Z"
                fill="url(#paint0_linear_4318_10745)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_4318_10745"
                  x1="-4.19589e-08"
                  y1="28.3118"
                  x2="103.966"
                  y2="25.3802"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#4C1270" stop-opacity="0" />
                  <stop offset="1" stop-color="#29287D" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="rightVideo">
            <div class="title ukiyo_bg">
              Gen2 - {{ $t("productCenterPDRHeaView").module.h13 }}
            </div>
            <video
              ref="videoPlayer"
              controlsList="nodownload"
              controls
              src="@/static/img/PDRHEA_ukiyo.mp4"
              muted
              autoplay
              loop
            ></video>
          </div>
        </div>
      </div>
    </div>
    <div id="module3">
      <div id="left" class="wow animate__animated animate__slideLeft">
        <div id="text">
          <div id="text1" class="module3">
            {{ $t("productCenterPDRHeaView").module.h5 }}
          </div>
          <div id="text2" class="module3">
            {{ $t("productCenterPDRHeaView").module.h6 }}
          </div>
        </div>
      </div>
      <div id="right" class="wow animate__animated animate__fromRight">
        <video
          ref="videoPlayer"
          controlsList="nodownload"
          src="@/static/img/PdRheaReflection.mp4"
          muted
          autoplay
          loop
        ></video>
      </div>
    </div>
    <div id="module4">
      <div id="left" class="wow animate__animated animate__slideLeft">
        <video
          ref="videoPlayer"
          controlsList="nodownload"
          src="@/static/img/Rodom.mp4"
          muted
          autoplay
          loop
        ></video>
      </div>
      <div id="right" class="wow animate__animated animate__fromRight">
        <div id="text">
          <div id="text1" class="module3">
            {{ $t("productCenterPDRHeaView").module.h7 }}
          </div>
          <div id="text2" class="module3">
            {{ $t("productCenterPDRHeaView").module.h8 }}
          </div>
        </div>
      </div>
    </div>
    <div id="module5">
      <div
        id="left"
        class="module5img wow animate__animated animate__slideLeft"
      >
        <div id="text">
          <div id="text1" class="module5">
            {{ $t("productCenterPDRHeaView").module.h9 }}
          </div>
          <template v-if="$i18n.locale === 'en-US'">
            <div id="text2" class="module5">
              {{
                $t("productCenterPDRHeaView").module.h10 +
                $t("productCenterPDRHeaView").module.h11
              }}
            </div>
          </template>
          <template v-else>
            <div id="text2" class="module5">
              {{ $t("productCenterPDRHeaView").module.h10 }}
            </div>
            <div id="text2" class="module5">
              {{ $t("productCenterPDRHeaView").module.h11 }}
            </div>
          </template>
        </div>
      </div>
      <div id="right" class="wow animate__animated animate__fromRight">
        <video
          ref="videoPlayer"
          controlsList="nodownload"
          src="@/static/img/PdRheaThree.mp4"
          muted
          autoplay
          loop
        ></video>
      </div>
    </div>
    <div
      id="module6"
      :style="{ 'background-image': 'url(' + imageUrl6 + ')' }"
      v-lazy="imageUrl6"
    >
      <div id="module6Content">
        <div id="title" class="wow animate__animated animate__fadeInUp">
          {{ $t("productCenterPDRHeaView").function.h1 }}
        </div>
        <div id="role" class="wow animate__animated animate__fadeInUp">
          <div id="roleLeft">
            <div id="icon1">
              <img src="@/static/img/rheaicon-21.png" alt="" />
            </div>
            <div id="icon2">
              <img src="@/static/img/rheaicon-11.png" alt="" />
            </div>
            <div id="font">
              <div id="iconTitle1">
                {{ $t("productCenterPDRHeaView").function.h2 }}
              </div>
              <div id="iconTitle2">
                {{ $t("productCenterPDRHeaView").function.h3 }}
              </div>
            </div>
          </div>
          <div id="roleRight">
            <div id="icon1">
              <img src="@/static/img/rheaicon-22.png" alt="" />
            </div>
            <div id="icon2">
              <img src="@/static/img/rheaicon-12.png" alt="" />
            </div>
            <div id="font">
              <div id="iconTitle1">
                {{ $t("productCenterPDRHeaView").function.h4 }}
              </div>
              <div id="iconTitle2">
                {{ $t("productCenterPDRHeaView").function.h5 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>
``

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  components: {
    FooterComponents,
  },
  data() {
    return {
      imageUrl1: require("@/static/img/rheaBanner.png"),
      imageUrl2: require("@/static/img/rheabannervideo.png"),
      imageUrl3: require("@/static/img/rhea3-GIF1.gif"),
      imageUrl4: require("@/static/img/PdRheaThree.mp4"),
      imageUrl5: require("@/static/img/PdRheaReflection.mp4"),
      imageUrl6: require("@/static/img/rheaFooter.png"),
    };
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
//左下到右上
:global(.animate__slideLeft) {
  animation-name: zoomInLeft;
}

@keyframes zoomInLeft {
  from {
    opacity: 0;
    transform: translate(-50%, 50%) scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* 可选：调整动画持续时间 */
:global(.animate__slideLeft) {
  animation-duration: 1s !important;
}

//右下到左上
:global(.animate__fromRight) {
  animation-name: zoomInRight;
}

@keyframes zoomInRight {
  from {
    opacity: 0;
    transform: translate(50%, 50%) scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* 可选：调整动画持续时间 */
:global(.animate__fromRight) {
  animation-duration: 1s !important;
}

@mixin whar($width, $height, $atio) {
  width: $width;
  height: $height;
  aspect-ratio: $atio;
  box-sizing: border-box;
}

@mixin display {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin commitaspct {
  opacity: 1;
  width: 50%;
  aspect-ratio: 720/600;
  background-size: contain;
}

@mixin fontStyle(
  $fontweight,
  $height,
  $fontSize,
  $lineHeight,
  $letterSpaceing,
  $color
) {
  width: fit-content;
  font-weight: $fontweight;
  height: $height;
  font-size: $fontSize;
  font-style: normal;
  line-height: $lineHeight;
  letter-spacing: $letterSpaceing;
  color: $color;
}

#fullpage {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
}

#module1 {
  background-size: cover;
  padding: 12.9375rem 0rem 0rem 12.8125rem;
  @include whar(100%, auto, 1440/480);

  .sup {
    font-weight: 400;
    font-size: 1rem;
    position: relative;
    top: -0.1875rem;
  }

  #text {
    width: fit-content;
    height: 7.75rem;
    line-height: 3.875rem;
    /* background-color: red; */

    #text1 {
      @include fontStyle(
        600,
        3.875rem,
        2.5rem,
        3.875rem,
        0.06944rem,
        rgba(255, 255, 255, 0.85)
      );
    }

    #text3 {
      opacity: 1;
      margin-top: 0.75rem;
      @include fontStyle(
        400,
        2rem,
        1.0625rem,
        2rem,
        0.06944rem,
        rgba(255, 255, 255, 0.65)
      );
    }
  }
}

#module2 {
  background-size: cover;
  padding: 4.875rem 0 6.0625rem 0;
  @include whar(100%, auto, 1440/758);
  @include display;

  #module2Content {
    #title1,
    #title2 {
      margin: auto;
    }

    #video {
      display: flex;
      justify-content: space-between;
      padding: 0 6rem;

      .leftVideo,
      .rightVideo {
        width: 45%;

        .title {
          width: 11rem;
          padding: 0.6875rem 0;
          border-radius: 0.25rem;
          text-align: center;
          margin: 0 auto;
          border: 0.0625rem solid #282553;
          color: rgba(255, 255, 255, 0.85);
          font-size: 1rem;
          font-style: normal;
          font-weight: 500;
        }

        .nirvana_bg {
          background: url("@/static/img/nirvana_bg.png") no-repeat;
          background-size: cover;
          background-color: #0c132b;
        }

        .ukiyo_bg {
          background: url("@/static/img/ukiyo_bg.png") no-repeat 100% 100%;
          background-size: cover;
          background-color: #0c132b;
        }

        video {
          width: 100%;
          margin-top: 2rem;
          object-fit: cover;
        }
      }

      .arrow {
        width: 10%;
        text-align: center;

        svg {
          width: 100%;
        }
      }
    }

    #title1 {
      @include fontStyle(
        600,
        3.125rem,
        2.25rem,
        3.125rem,
        0.06944rem,
        rgba(255, 255, 255, 0.85)
      );
    }

    #title2 {
      margin-top: 1rem;
      @include fontStyle(
        400,
        1.625rem,
        1rem,
        1.625rem,
        0.06944rem,
        rgba(255, 255, 255, 0.65)
      );
    }

    #video {
      width: fit-content;
      margin-top: 3.5625rem;

      video {
        width: 50.375rem;
        aspect-ratio: 806/453;
        object-fit: cover;
      }
    }
  }
}

#module3 {
  /* width: 100%; */
  display: flex;
  margin-top: -0.5rem;

  #left {
    width: 50%;
    @include display;
    /* background-color: red; */

    #text {
      height: 5rem;
      width: fit-content;

      #text1,
      #text2 {
        backdrop-filter: blur(1.25rem);
        @include fontStyle(
          600,
          2.5rem,
          1.5rem,
          2.5rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }
    }
  }

  #right {
    width: 50%;
    /* background-color: yellow; */
    /* align-self: flex-end; */

    video {
      width: 100%;
      height: 101.8%;
      object-fit: contain;
    }
  }
}

#module4 {
  width: 100%;
  display: flex;

  #left {
    /* @include commitaspct; */
    width: 50%;
    /* background-color: rgb(25, 250, 138); */

    video {
      width: 100%;
      height: 100.5%;
      /* object-fit: contain; */
    }
  }

  #right {
    width: 50%;
    @include display;

    #text {
      height: 8rem;
      width: fit-content;
      padding: 0 1rem;

      #text1,
      #text2 {
        backdrop-filter: blur(1.25rem);
        @include fontStyle(
          600,
          2.5rem,
          1.5rem,
          2.5rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }
    }
  }
}

#module5 {
  width: 100%;
  display: flex;
  margin-top: -0.2rem;

  #left {
    width: 50%;
    @include display;

    #text {
      height: 5rem;
      width: fit-content;

      #text1 {
        margin-bottom: 1.25rem;
        backdrop-filter: blur(1.25rem);
        @include fontStyle(
          600,
          2.5rem,
          1.5rem,
          2.5rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #text2,
      #text3 {
        backdrop-filter: blur(1.25rem);
        @include fontStyle(
          400,
          1.625rem,
          1.2rem,
          1.625rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  #right {
    width: 50%;

    video {
      width: 100%;
      height: 100%;
    }
  }
}

#module6 {
  @include whar(100%, auto, 2880/964);
  background-size: cover;
  @include display;

  #module6Content {
    width: 100%;
    /* background-color: red; */

    #title {
      @include fontStyle(
        600,
        3.125rem,
        2.25rem,
        3.125rem,
        0.06944rem,
        rgba(255, 255, 255, 0.85)
      );
      margin: auto;
    }

    #role {
      margin: auto;
      display: flex;
      width: 90%;
      margin-top: 3.5625rem;

      #roleLeft,
      #roleRight {
        width: 50%;
        position: relative;
        box-sizing: border-box;
        border-radius: 0.25rem;
        padding-left: 2.75rem;
        padding-right: 2.75rem;
        padding-bottom: 2rem;
        backdrop-filter: blur(0.625rem);
        box-shadow: 0px 1.5rem 2.5rem rgba(12, 12, 12, 0.4);
        background: linear-gradient(
          192.98deg,
          rgba(128, 186, 240, 0.1) 22.73%,
          rgba(16, 28, 60, 0.1) 72.38%
        );

        #icon1 {
          margin-top: 2rem;
          width: 4rem;
          height: 4rem;
          /* background-color: red; */

          img {
            width: 4rem;
            height: 4rem;
            object-fit: fill;
          }
        }

        #icon2 {
          top: 0rem;
          right: 0rem;
          position: absolute;
          border-radius: 0.25rem;

          img {
            width: 10rem;
            object-fit: cover;
            height: 11.5625rem;
          }
        }

        #font {
          // height: 4.625rem;
          /* background-color: green; */
          /* margin-bottom: 2rem; */
          margin-top: 1.5625rem;

          #iconTitle1 {
            // backdrop-filter: blur(20px);
            /* background-color: red; */
            @include fontStyle(
              600,
              2.5rem,
              1.5rem,
              2.5rem,
              0.06944rem,
              rgba(255, 255, 255, 0.85)
            );
          }

          #iconTitle2 {
            /* background-color: red; */
            margin-top: 0.5rem;
            @include fontStyle(
              400,
              // 1.625rem,
              auto,
              0.875rem,
              1.625rem,
              0.06944rem,
              rgba(255, 255, 255, 0.65)
            );
          }
        }
      }

      #roleLeft {
        margin-right: 1.25rem;
      }
    }
  }
}

#footer {
  width: 100%;
  height: 18rem;
}

.en {
  #module3,
  #module4,
  #module5 {
    #text {
      width: 70% !important;
    }
  }
  #module6 {
    #iconTitle2 {
      line-height: 1.5 !important;
      // text-align: justify !important;
    }
  }
}
</style>
